module.exports = __webpack_public_path__ + "static/media/gigi-play.e84108c8.jpg";